module.exports = __webpack_public_path__ + "static/media/hatsu.8c41518e.png";